var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeHoverPortfolioManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01251 18.4749V4.0249H1.01251V18.4624C1.01251 19.2874 1.68751 19.9624 2.51251 19.9624L22.9875 19.9124V18.9124L2.51251 18.9624C2.23751 18.9749 2.01251 18.7499 2.01251 18.4749ZM22.4875 4.0249H19.2625V5.0249H21.275L13.65 12.6499L11.0625 10.0624C10.8625 9.8624 10.55 9.8624 10.35 10.0624L3.37501 17.0499L4.08751 17.7624L10.7125 11.1374L13.3 13.7249C13.5 13.9249 13.8125 13.9249 14.0125 13.7249L22 5.7374V7.7499H23V4.5249C22.9875 4.2499 22.7625 4.0249 22.4875 4.0249Z",
    fill: "#001317"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHoverPortfolioManagement);
export default __webpack_public_path__ + "static/media/home-hover-portfolio-management.7ed64d01ba215d3fc15b7d96c3d4c7bc.svg";
export { ForwardRef as ReactComponent };